export default __webpack_public_path__ + "static/media/preview-image(1).4501a17b.png";